import { useGetUserProfileByAddress } from '@/api/query'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { Flex, Box, Text } from '@chakra-ui/react'
import { AvatarCircle } from '../Avatar'
import { GradientText } from '../GradientText/GradientText'

export const UserProfile = ({ address, borderColor = 'brand.green' }: { address: string; borderColor?: string }) => {
  const { data } = useGetUserProfileByAddress(address)
  const modal = useAppModal()

  const numberOfNfts = data?.nfts?.totalCount
  const isNftOwner = Boolean(numberOfNfts)

  return (
    <Flex
      cursor={'pointer'}
      onClick={() => modal.openModalNew(AppModals.UserStats, { address })}
      gap={3}
      alignItems={'center'}
    >
      <Box
        border={'1px solid'}
        borderColor={'transparent'}
        transition={'.2s'}
        _hover={{
          borderColor,
        }}
        rounded={'full'}
      >
        <Box border={'1px solid'} borderColor={borderColor} p={'2px'} rounded={'full'}>
          <AvatarCircle src={data?.user?.profileAvatar || ''} />
        </Box>
      </Box>
      {isNftOwner ? (
        <GradientText
          numberOfNfts={numberOfNfts!}
          props={{
            fontWeight: 600,
            fontSize: 'sm',
          }}
        >
          {data?.user?.profileUserName}
        </GradientText>
      ) : (
        <Text color={'ninja.100'} fontSize={'sm'} fontWeight={'500'}>
          {data?.user?.profileUserName}
        </Text>
      )}
    </Flex>
  )
}
